var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAutoAlertRuleBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "AddRule_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1182",
    "data-name": "Rectangle 1182",
    width: 24,
    height: 24,
    fill: "#165cf3",
    opacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1183",
    "data-name": "Rectangle 1183",
    width: 22,
    height: 22,
    transform: "translate(1 1.06)",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkmark-outline",
    d: "M12.5,6.77,10.91,8.6l-.68-.68",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.97
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "checkmark-outline-2",
    d: "M12.5,11.15l-1.59,1.83-.68-.68",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.97
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    d: "M22.25,10.67v2.12",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_974-2",
    d: "M7.61,15.72V2.54l1.46.73,1.46-.73,1.46.73,1.49-.73,1.45.73,1.45-.73,1.46.73,1.48-.73,1.46.73,1.46-.73V6.41",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    d: "M22.25,12.79v5.13a3.662,3.662,0,0,1-3.66,3.66h0a3.662,3.662,0,0,1-3.66-3.66v-2.2H2.48a.726.726,0,0,0-.73.72v.01c0,2.93.31,5.13,3.66,5.13H18.59",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    d: "M15.15,7.29h4.17m-2.78,4.55h2.78",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "add-circle",
    d: "M18.5,13.54a4.5,4.5,0,1,0,4.5,4.5,4.494,4.494,0,0,0-4.5-4.5Zm1.73,4.85H18.85v1.38a.35.35,0,0,1-.7,0V18.39H16.77a.35.35,0,1,1,0-.7h1.38V16.31a.35.35,0,0,1,.7,0v1.38h1.38a.35.35,0,0,1,0,.7Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(21.58 8.02)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAutoAlertRuleBtnIcon);
export default __webpack_public_path__ + "static/media/add-auto-alert-rule-btn-icon.68925b62702b38c9fb24c1139f7de0e9.svg";
export { ForwardRef as ReactComponent };